var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.likeIt(_vm.comment)}}},[_c('v-icon',{staticClass:"mx-1",attrs:{"small":"","color":_vm.color}},[_vm._v("mdi-thumb-up-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }